import PropTypes from 'prop-types';
import React from 'react';
import CSSModules from 'react-css-modules';
import styles from './Home.less';
import Categories from './Categories';
import Featured from './Featured';
import Fees from './Fees';
import GetStarted from './GetStarted';
import Faq from './Faq';
import Heroes from './Heroes';
import Testimonials from './Testimonials';

const Home = ({
  carouselPages,
  filteredPages,
  filter,
  isLoading,
  loadFilteredPages,
  changePagesFilter,
  activePagesCount,
  avatars,
  loadAvatars,
  loadCategoryPage,
  getStarted,
  seeMoreFaq,
  selectCard,
  slideCarousel,
}) => (
  <div>
    <Heroes slideCarousel={slideCarousel} />
    <Categories loadCategoryPage={loadCategoryPage} getStarted={getStarted} />
    <Featured
      carouselPages={carouselPages}
      filteredPages={filteredPages}
      filter={filter}
      isLoading={isLoading}
      loadMorePages={loadFilteredPages}
      changeFilter={changePagesFilter}
      activePagesCount={activePagesCount}
      loadAvatars={loadAvatars}
      avatars={avatars}
      selectCard={selectCard}
      slideCarousel={slideCarousel}
    />
    <Testimonials getStarted={getStarted} />
    <Fees />
    <GetStarted getStarted={getStarted} />
    <Faq seeMore={seeMoreFaq} />
  </div>
);

Home.propTypes = {
  carouselPages: PropTypes.arrayOf(
    PropTypes.shape({
      projectType: PropTypes.string.isRequired,
      targetCurrency: PropTypes.string.isRequired,
      amountRaised: PropTypes.number.isRequired,
      progress: PropTypes.number.isRequired,
      pitch: PropTypes.string.isRequired,
      owner: PropTypes.string.isRequired,
      numberOfSupporters: PropTypes.number.isRequired,
      projectId: PropTypes.string.isRequired,
      projectUrl: PropTypes.string.isRequired,
      projectImage: PropTypes.shape({
        url: PropTypes.string,
        width: PropTypes.number,
        height: PropTypes.number,
        cropArea: PropTypes.shape({
          top: PropTypes.number,
          left: PropTypes.number,
          width: PropTypes.number,
          height: PropTypes.number,
        }),
      }),
    }).isRequired
  ).isRequired,
  filteredPages: PropTypes.shape({
    totalCount: PropTypes.number.isRequired,
    pageNo: PropTypes.number.isRequired,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        projectType: PropTypes.string.isRequired,
        targetCurrency: PropTypes.string.isRequired,
        amountRaised: PropTypes.number.isRequired,
        progress: PropTypes.number.isRequired,
        pitch: PropTypes.string.isRequired,
        owner: PropTypes.string.isRequired,
        numberOfSupporters: PropTypes.number.isRequired,
        projectId: PropTypes.string.isRequired,
        projectUrl: PropTypes.string.isRequired,
        projectImage: PropTypes.shape({
          url: PropTypes.string,
          width: PropTypes.number,
          height: PropTypes.number,
          cropArea: PropTypes.shape({
            top: PropTypes.number,
            left: PropTypes.number,
            width: PropTypes.number,
            height: PropTypes.number,
          }),
        }),
      }).isRequired
    ).isRequired,
  }).isRequired,
  filter: PropTypes.shape({
    categoryId: PropTypes.number.isRequired,
    typeId: PropTypes.number.isRequired,
    locationId: PropTypes.number.isRequired,
  }),
  isLoading: PropTypes.bool.isRequired,
  loadFilteredPages: PropTypes.func.isRequired,
  changePagesFilter: PropTypes.func.isRequired,
  activePagesCount: PropTypes.number.isRequired,
  avatars: PropTypes.objectOf(PropTypes.string),
  loadAvatars: PropTypes.func.isRequired,
  loadCategoryPage: PropTypes.func.isRequired,
  getStarted: PropTypes.func.isRequired,
  seeMoreFaq: PropTypes.func.isRequired,
  selectCard: PropTypes.func.isRequired,
  slideCarousel: PropTypes.func.isRequired,
};

export default CSSModules(Home, styles, {
  allowMultiple: true,
});



// WEBPACK FOOTER //
// ./src/components/Home/Home.js